import { getFlowDataDirect, useFlowData } from "@adaptis/flow-components";
import _ from "lodash";
import { getPetQty, updateTotalAmounts } from "./data-store";

// Check digit funtions =======================================================
export function getCheckDigit(value: string): undefined | number {
  if (/[^0-9-\s]+/.test(value)) return undefined;

  var nCheck = 0,
    nDigit = 0,
    bEven = true;
  value = value.replace(/\D/g, "");

  for (var n = value.length - 1; n >= 0; n--) {
    var cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);

    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }
  return (1000 - nCheck) % 10;
}

export function isCheckdigitCorrect(value: string): boolean {
  // accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(value)) return false;

  var nCheck = 0,
    nDigit = 0,
    bEven = false;
  value = value.replace(/\D/g, "");

  for (var n = value.length - 1; n >= 0; n--) {
    var cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);

    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 == 0;
}

export function calculatePriceFromPaymentFrequency(
  paymentFrequency: string,
  total: number,
  firstMonthDiscounted: number
) {

  let installmentAmount = total;
  switch (paymentFrequency) {
    case "Monthly":
      installmentAmount = Math.max(firstMonthDiscounted, 0);
      break;
    case "Fortnightly":
      installmentAmount = ((Math.max(firstMonthDiscounted, 0)) * 12) / 26.07;
  }
  return installmentAmount;
}
export function getGTMQuoteDataEventName(location: string) {
  if (location.includes("step-1")) return "Clicked_Get_Started";
  else if (location.includes("step-2")) return "Add_Pet_Detail";
  else if (location.includes("edit-cover-1")) return "Provided_Name_breed";
  else if (location.includes("edit-cover-2")) return "Provided_dob_sex";
  else if (location.includes("edit-cover-3")) return "Provided_policy_start";
  else if (location.includes("custom-cover")) return "Custom_Cover_Details";
  else if (location.includes("step-3")) return "Policyholder Details Completed";
  else if (location.includes("step-5")) return "Payment Details Completed";
  else if (location.includes("success")) return "New Policy Purchased";
  else return location;
}

export function getGTMQuoteData(
  step: any,
  data: any | undefined = undefined,
  petId: any | undefined = undefined
) {
  let allPets = getFlowDataDirect("pets");
  let clonedPets = _.cloneDeep(allPets);
  let petQty = getPetQty(allPets);

  let session_id = getFlowDataDirect("sessionId") ?? "";
  let holderFirstName = getFlowDataDirect("holderFirstName");
  let holderEmail = getFlowDataDirect("holderEmail");
  let postcode = getFlowDataDirect("holderAddress.postcode");
  let state = getFlowDataDirect("holderAddress.state");
  let suburb = getFlowDataDirect("holderAddress.suburb");
  let holderLastName = getFlowDataDirect("holderLastName");
  let address1 = getFlowDataDirect("holderAddress.line1");
  let address2 = getFlowDataDirect("holderAddress.line2");
  let phone = getFlowDataDirect("holderPhone");
  let holderDOB = getFlowDataDirect("holderDOB");
  let sendQuoteToEmail = getFlowDataDirect("sendQuoteToEmail") ?? "";
  let sendQuoteToPhone = getFlowDataDirect("sendQuoteToPhone") ?? "";
  let quoteNo = getFlowDataDirect("quoteNo") ?? "";
  let promoCode = getFlowDataDirect("promoCode");

  let currentPet = {
    name: "",
    breed: "",
    petDOB: "",
    petSex: "",
    isDesexed: "",
    startDate: "",
    petAgeCategory: 0,
  };

  if (petId) {
    allPets.forEach((pet: any) => {
      if (pet != undefined && pet.id === petId) {
        currentPet = pet;
        return;
      }
    });
  }

  //console.log(currentPet);

  updateTotalAmounts();

  let totalAmounts = getFlowDataDirect("totalAmounts");
  let totalAmountsMonthly = getFlowDataDirect("totalAmounts.installmentAmount");
  let totalAmountsYearly = totalAmountsMonthly != undefined ? totalAmountsMonthly * 12 : 0;

  let quoteData = {};

  if (!step) {
    quoteData = {};
  } else if (step.includes("step-1")) {
    quoteData = {
      Session_id: session_id,
      "Number Of Dogs": petQty.dogQty,
      "Number Of Cats": petQty.catQty,
      Holder_First_Name: holderFirstName,
      Holder_State: state,
      Holder_Suburb: suburb,
      Holder_Post_Code: postcode,
      Holder_Email: holderEmail,
    };
  } else if (step.includes("edit-cover-1")) {
    quoteData = {
      Session_id: session_id,
      Pet_1_pet_name: currentPet.name,
      Pet_1_Breed_name: currentPet.breed,
    };
  } else if (step.includes("edit-cover-2")) {
    quoteData = {
      Session_id: session_id,
      Pet_1_Date_of_birth: currentPet.petDOB,
      Pet_1_Gender: currentPet.petSex,
      Pet_1_Desexed: currentPet.isDesexed,
    };
  } else if (step.includes("edit-cover-3")) {
    quoteData = {
      Session_id: session_id,
      Pet_1_Req_Policy_start_Date: currentPet.startDate,
    };
  } else if (step.includes("step-2")) {
    quoteData = {
      Session_id: session_id,
      pets: clonedPets,
    };
  } else if (step.includes("custom-cover")) {
    quoteData = {
      Session_id: session_id,
      pets: clonedPets,
      totalAmounts: totalAmounts,
    };
  } else if (step.includes("step-3")) {
    quoteData = {
      Session_id: session_id,
      Holder_First_Name: holderFirstName,
      Holder_Last_Name: holderLastName,
      Holder_Address_1: address1,
      Holder_Address_2: address2,
      Holder_State: state,
      Holder_Suburb: suburb,
      Holder_Post_Code: postcode,
      Holder_Email: holderEmail,
      Holder_Phone: phone,
      Holder_DOB: holderDOB
    };
  } else if (step.includes("step-5")) {
    quoteData = {
      Session_id: session_id,
      promoCode: promoCode,
      "Total Monthly Amount Payable": totalAmountsMonthly,
      "Total Annual Price": totalAmountsYearly,
    };
  } else if (step == "Send Quote") {
    quoteData = {
      Session_id: session_id,
      Quote_number: quoteNo,
      Send_Quote_To_Email: sendQuoteToEmail,
      Send_Quote_To_Phone: sendQuoteToPhone,
      promoCode: promoCode,
      pets: clonedPets,
      totalAmounts: totalAmounts,
    };
  } else if (step == "New Policy Purchased") {
    quoteData = {
      Session_id: session_id,
      "Number Of Dogs": petQty.dogQty,
      "Number Of Cats": petQty.catQty,
      Holder_First_Name: holderFirstName,
      Holder_Last_Name: holderLastName,
      Holder_Address_1: address1,
      Holder_Address_2: address2,
      Holder_State: state,
      Holder_Suburb: suburb,
      Holder_Post_Code: postcode,
      Holder_Email: holderEmail,
      Holder_Phone: phone,
      Holder_DOB: holderDOB,
      Quote_number: quoteNo,
      promoCode: promoCode,
      pets: clonedPets,
      totalAmounts: totalAmounts,
    };
  } else {
    quoteData = {
      Session_id: session_id,
      promoCode: promoCode,
    };
  }

  if (data != undefined) {
    quoteData = {
      Session_id: session_id,
      data,
    };
  }

  if (step == undefined && data == undefined) return undefined;

  return quoteData;
}

export function convertKnose2MM(pets: any[], customer: any, refs: any): any {
  let mmData: any = {
    pets,
    customer,
    brand: "PETSY",
    payment_frequency: "monthly",
    refs
  };
  return mmData;
}

export function convertMM2Knose(mmData: any) {
  console.log("mmData", mmData);
  let { quote } = mmData.data;
  let knoseData = {};

  return knoseData;
}

export function getPetIndexFromId(petNo: string, pets: any[]) {
  // console.log("getPetIndexFromId", pets);
  let myIndex: number = pets.findIndex((pet: any) => pet.pet_no === petNo);
  return myIndex;
}

export function getAFXProfile() {
  var a: any = "afx_profile";
  a = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(a).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  return a ? (a = JSON.parse(a), a.acid) : "(not set)"
}
// ============================================================================
